const myCasaMenuLinks = [
  {
    title: {
      txt: 'Pubblica annunci',
      isNew: true,
    },
    domain: 'mycasa',
    hasAuthPrefix: false,
    links: [
      {
        txt: 'Nuovo annuncio',
        url: '/pubblica/nuovo',
      },
      {
        txt: 'I tuoi annunci',
        url: '/pubblica/annunci',
      },
    ],
    hideIfBlacklisted: true,
  },
  {
    title: {
      txt: 'Preferiti',
      isNew: false,
    },
    domain: 'mycasa',
    hasAuthPrefix: true,
    links: [
      {
        txt: 'Annunci salvati',
        url: '/annunci/preferiti',
      },
      {
        txt: 'Ricerche / Email Alert',
        url: '/ricerche/preferiti',
      },
      {
        txt: 'Note',
        url: '/annunci/note',
      },
    ],
    hideIfBlacklisted: false,
  },
  {
    title: {
      txt: 'Strumenti utili',
      isNew: false,
    },
    domain: 'portal',
    links: [
      {
        txt: 'Valuta la tua casa',
        url: '/valutazione-immobile/',
      },
      {
        txt: 'Chiedi a un\'agenzia',
        url: '/agenzie/',
      },
      {
        txt: 'Domande frequenti',
        url: '/casait/faq/',
      },
    ],
    hideIfBlacklisted: false,
  },
  {
    title: {
      txt: 'Cronologia',
      isNew: false,
    },
    domain: 'mycasa',
    hasAuthPrefix: true,
    links: [
      {
        txt: 'Annunci',
        url: '/annunci/recenti',
      },
      {
        txt: 'Ricerche',
        url: '/ricerche/recenti',
      },
    ],
    hideIfBlacklisted: false,
  },
];
export default myCasaMenuLinks;
